import React from 'react';
import { Route, Switch } from 'react-router';

import CustomerCreate from './CustomerCreate';
import CustomerDetail from './CustomerDetail';
import CustomerList from './CustomerList/CustomerList';
import CustomerProductsSyncDialog from './CustomerProductsSyncDialog/CustomerProductsSyncDialog';
import CustomerServicesSyncDialog from './CustomerServicesSyncDialog/CustomerServicesSyncDialog';

export default function Customers() {
  return (
    <>
      <Route
        path="/customers/:id/products"
        component={CustomerProductsSyncDialog}
      />
      <Route
        path="/customers/:id/services"
        component={CustomerServicesSyncDialog}
      />
      <Switch>
        <Route path="/customers/create" component={CustomerCreate} />
        <Route path="/customers/:id" component={CustomerDetail} />
        <Route path="/customers" component={CustomerList} />
      </Switch>
    </>
  );
}
